import React from 'react';

function formatDate(dateStr) {
  if (!dateStr) return '—';
  const [y, m, d] = dateStr.slice(0, 10).split('-');
  if (!y || !m || !d) return '—';
  return `${d}/${m}/${y}`;
}

export default function PersonCard({ person, hideDetails }) {
  const initials = person.name.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase();

  return (
    <div className="info-card">
      <div className="person-avatar">{initials}</div>
      <h2>{person.name}</h2>
      <p className="dates-icons">
        {!hideDetails && person.birth_date && (
          <span className="date-item birth-date" title="Data de nascimento">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" stroke="none">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
            </svg>
            {formatDate(person.birth_date)}
          </span>
        )}
        {person.death_date && (
          <span className="date-item death-date" title="Data de falecimento">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" stroke="none">
              <path d="M10 3h4v5h5v4h-5v9h-4v-9H5V8h5z" />
            </svg>
            {formatDate(person.death_date)}
          </span>
        )}
        {!person.birth_date && !person.death_date && '—'}
      </p>
      {!hideDetails && (
        <div className="info-details">
          <div className="info-detail-item">
            <label>Jazigo</label>
            <strong>{person.number}</strong>
          </div>
          <div className="info-detail-item">
            <label>Quadra</label>
            <strong>{person.block}</strong>
          </div>
          {person.sector ? (
            <div className="info-detail-item">
              <label>Setor</label>
              <strong>{person.sector}</strong>
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
}
